import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  src: "/img/logo-text.svg",
  alt: ""
}
const _hoisted_2 = {
  key: 1,
  src: "/img/logo.svg",
  alt: ""
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Logo',
  props: {
    withText: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.withText)
    ? (_openBlock(), _createElementBlock("img", _hoisted_1))
    : (_openBlock(), _createElementBlock("img", _hoisted_2))
}
}

})